import { Button, Paper, Typography } from '@mui/material';
import React from 'react';
import { useNavigate } from 'react-router-dom';

import { playCue } from '../tarot/feedback';

export interface CallToActionProps {
    title: string;
    body: string;
    button: string;
    /** The app feature the button opens: `/birth-chart`, `/ritual/daily`, `/breathe`... */
    to: string;
}

/** A framed invitation to one feature of the app, reused at the end of every content page. */
export const CallToAction: React.FC<CallToActionProps> = ({
    title,
    body,
    button,
    to,
}) => {
    const navigate = useNavigate();
    return (
        <Paper
            component="aside"
            sx={{
                mt: 4,
                p: 3,
                textAlign: 'center',
                background: 'rgba(21,14,36,.92)',
                border: 1,
                borderColor: 'primary.main',
            }}
        >
            <Typography variant="h6" component="h2" gutterBottom>
                {title}
            </Typography>
            <Typography color="text.secondary" sx={{ mb: 2 }}>
                {body}
            </Typography>
            <Button
                variant="contained"
                size="large"
                onClick={() => {
                    playCue('ui');
                    navigate(to);
                }}
            >
                {button}
            </Button>
        </Paper>
    );
};
